import { createAction, handleActions } from 'redux-actions';
import createRequestSaga, {
  createRequestActionTypes,
} from '../../lib/createRequestSaga';
import { takeLatest } from 'redux-saga/effects';
import * as departApi from '../../lib/api/department';


const [VIEW_DEPART, VIEW_DEPART_SUCCESS, VIEW_DEPART_FAILURE] =
  createRequestActionTypes('depart/VIEW_DEPART');
export const viewDepart = createAction(VIEW_DEPART, (id) => id);
 const viewDepartSaga = createRequestSaga(VIEW_DEPART, departApi.getDepart);



const UNLOAD_DEPART = 'depart/UNLOAD_DEPART';
export const unloadDepart = createAction(UNLOAD_DEPART);

const SET_DEPART = 'depart/SET_DEPART';
export const setDepart = createAction(SET_DEPART, (depart) => depart);


export function* departSaga() {
  yield takeLatest(VIEW_DEPART, viewDepartSaga);
}

const initialState = {
  depart: null,
  error: null,
};

const depart = handleActions(
  {
    [VIEW_DEPART_SUCCESS]: (state, { payload: data }) => ({
      ...state,
      depart: data.info,
    }),
    [VIEW_DEPART_FAILURE]: (state, { payload: error }) => ({
      ...state,
      error,
    }),
    [SET_DEPART]: (state, { payload: depart }) => ({
      ...state,
      depart: depart,
    }),
    [UNLOAD_DEPART]: () => initialState,
  },
  initialState,
);

export default depart;
